import i18n from "../i18n";
import logger from "./logging";

/**
 * Formats the date in a human-readable way
 * @param dateValue expects a date or a string in the format ISO 8601 Instant
 */
export const formatDate = (dateValue: string | Date | undefined | null): string => {
    if (typeof dateValue === "string") {
        dateValue = new Date(dateValue);
    }

    if (dateValue instanceof Date) {
        // follow the UI language, not the browser language
        const locale = i18n.resolvedLanguage ?? navigator.language;
        const formatted = new Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "short" }).format(dateValue);
        if (locale.startsWith("de")) {
            return `${formatted} Uhr`;
        }
        return formatted;
    }
    if (dateValue == null) {
        return "-";
    }

    logger.error("unknown date type: ", dateValue);
    return "[unknown]";
};
